import Step from "./Step";
import StepModel from "../../../model/configurator/StepModel";
import Field from "../../../model/configurator/Field";
import ReservedPressureDropForDPCPercent
    from '../../../model/configurator/primarySideEquipment/ReservedPressureDropForDPCPercent';
import ReservedPressureDropForDPCPressure
    from '../../../model/configurator/primarySideEquipment/ReservedPressureDropForDPCPressure';
import ExpandableContainer from "./ExpandableContainer";
import * as Row from '../../layout/Row';
import StepHorizontalField from "./StepHorizontalField";
import store from '../../../store/configuration';
import WarningsContainer from '../../common/WarningsContainer';

export default class StepPrimarySideEquipment extends Step {
    renderBody(model) {
        model = model.primarySideEquipment
        return (
            <React.Fragment>
                <ExpandableContainer label={__('General information')} initialOpen={true}>
                    <Row.Container hasOuterGutter={false}>
                        <div className="column-8 column-xs-12">
                            {this.renderGenericHorizontalField(this.fields.primaryMainPipeSize)}

                            <Row.Container hasGutter={false} style={{marginTop: '1rem'}}>
                                <Row.Column5></Row.Column5>
                                <Row.Column7 style={{paddingLeft: 0, marginLeft: -15}}>
                                    {this.renderFieldv2(this.fields.picv)}
                                </Row.Column7>
                            </Row.Container>

                            {this.renderGenericHorizontalField(this.fields.controlValveManufacturer)}

                            <Row.Container hasGutter={false} style={{marginTop: '1rem'}}>
                                <Row.Column5></Row.Column5>
                                <Row.Column7 style={{paddingLeft: 0, marginLeft: -15}}>
                                    {this.renderFieldv2(this.fields.flangedControlValvesDemanded)}
                                    {this.renderFieldv2(this.fields.rtzActuatorDemanded)}
                                </Row.Column7>
                            </Row.Container>
                            <Row.Container hasGutter={false} style={{marginTop: '1rem'}}>
                                <Row.Column5></Row.Column5>
                                <Row.Column7 style={{paddingLeft: 0, marginLeft: -15}}>
                                    {this.renderFieldv2(this.fields.differentialPressureControllerDPC)}
                                </Row.Column7>
                            </Row.Container>
                        </div>
                    </Row.Container>
                </ExpandableContainer>

                {this.fields.differentialPressureControllerDPC.value == true && this.renderDPCSection()}

                {typeof model.heating1 !== 'undefined' && this.renderHeatingSection(1, this.fields.heating1)}
                {typeof model.heating2 !== 'undefined' && this.renderHeatingSection(2, this.fields.heating2)}
                {typeof model.heating3 !== 'undefined' && this.renderHeatingSection(3, this.fields.heating3)}
                {typeof model.dhw !== 'undefined' && this.renderDHWSection(this.fields.dhw)}

                {this.renderSection(this.fields.dhStrainer, this.fields.pressureMetering, this.fields.thermometerPrimarySupply,
                        this.fields.thermometerPrimaryReturn, this.fields.dhFlowRetShutOff, this.fields.primaryOutPipeEMS, this.fields.energyMeter) &&
                    <ExpandableContainer label={__('Other components')}>
                        <Row.Container hasOuterGutter={false}>
                            <div className="column-8 column-xs-12">
                                {this.renderGenericHorizontalField(this.fields.dhStrainer)}
                                {this.renderGenericHorizontalField(this.fields.pressureMetering)}
                                {this.renderGenericHorizontalField(this.fields.thermometerPrimarySupply)}
                                {this.renderGenericHorizontalField(this.fields.thermometerPrimaryReturn)}
                                {this.renderGenericHorizontalField(this.fields.dhFlowRetShutOff)}
                                {this.renderGenericHorizontalField(this.fields.primaryOutPipeEMS)}
                                {this.renderGenericHorizontalField(this.fields.energyMeter)}
                                {this.renderGenericHorizontalField(this.fields.shutOffValvePrimarySupply)}
                                {this.renderGenericHorizontalField(this.fields.shutOffValvePrimaryReturn)}
                            </div>
                        </Row.Container>
                    </ExpandableContainer>}
            </React.Fragment>
        )
    }

    renderDPCSection() {
        const setPrimaryFlowForDPCSizingDefaultValue = () => {
            this.fields.primaryFlowForDPCSizing.value = this.fields.primaryFlowForDPCSizing.default
            if (this.props.onFormModelChange) {
                this.props.onFormModelChange()
            }
        }

        const getPrimaryFlowForDPCSizingTips = () => {
            return [this.fields.primaryFlowForDPCSizing.description]
        }

        const getDPCPressureDropTips = () => {
            return [`${__('Pressure drop')}: ${this.fields.dpcPressureDrop.value} ${this.fields.dpcPressureDrop.unit}`]
        }

        return (
            <ExpandableContainer warnings={[]} label={__('Differential pressure controller')}>
                <Row.Container hasOuterGutter={false}>
                    <div className="column-8 column-xs-12">
                        {this.renderGenericHorizontalField(this.fields.primaryFlowForDPCSizing, {}, getPrimaryFlowForDPCSizingTips(), setPrimaryFlowForDPCSizingDefaultValue)}
                        {this.renderGenericHorizontalField(this.fields.reservedPressureDropForDPCPercent, {label: __('Reserved pressure drop for DPC')})}
                        {this.renderGenericHorizontalField(this.fields.reservedPressureDropForDPCPressureDrop, {label: __('Reserved pressure drop for DPC')})}
                        {this.renderGenericHorizontalField(this.fields.differentialPressureController, {}, getDPCPressureDropTips())}
                    </div>
                </Row.Container>
            </ExpandableContainer>
        )
    }

    renderHeatingSection(index, fields) {
        const warnings = this.getCircuitWarnings(fields);
        return (
            <ExpandableContainer warnings={warnings} label={this.props.model['heating' + index].name.value}>
                <Row.Container hasOuterGutter={false}>
                    {this.renderHeatingSectionFields(fields, true, index)}
                </Row.Container>
            </ExpandableContainer>
        )
    }

    renderDHWSection(fields) {
        const warnings = this.getCircuitWarnings(fields);

        return (
            <ExpandableContainer warnings={warnings} label={this.props.model.dhw.name.value}>
                <Row.Container hasOuterGutter={false}>

                    {this.renderHeatingSectionFields(fields)}

                </Row.Container>
            </ExpandableContainer>
        )
    }

    getCircuitWarnings(fields) {
        const warnings = [fields.cvFlow.warning, fields.controlValvePressureDrop.warning];
        const {valveFields, picvValveFields, actuatorTypeFields} = this.getCVControls(fields);
        valveFields.filter(x => x.warning).map(x => warnings.push(x.warning));
        picvValveFields.filter(x => x.warning).map(x => warnings.push(x.warning));
        actuatorTypeFields.filter(x => x.warning).map(x => warnings.push(x.warning));

        return warnings;
    }

    getCVControls(fields) {
        var wrapper = {
            valveFields: [],
            picvValveFields: [],
            kvsFields: [],
            actuatorTypeFields: []
        }

        for (let i = 1; i <= fields.numberOfControlValves.value; i++) {
            let f = fields['cv' + i];
            if (f === undefined)
                break;

            wrapper.valveFields.push(f.controlValve);
            wrapper.picvValveFields.push(f.controlValvePICV);
            wrapper.kvsFields.push(f.kvs);
            wrapper.actuatorTypeFields.push(f.actuatorType);
        }

        return wrapper;
    }

    get3WVControls(fields) {
        return {
            valveFields: [fields.threeWayValve.controlValve],
            kvsFields: [fields.threeWayValve.kvs],
            actuatorTypeFields: [fields.threeWayValve.actuatorType]
        };
    }

    renderHeatingSectionFields(fields, isHeating = false, index = null) {
        const {valveFields, picvValveFields, kvsFields, actuatorTypeFields} = this.getCVControls(fields);
        const heatingModel = index === null ? null : this.props.model[`heating${index}`];
        return (
            <React.Fragment>
                <div className="column-8 column-xs-12">
                    {this.renderGenericHorizontalField(fields.numberOfControlValves)}
                    {this.renderGenericHorizontalField(fields.availableDP, {}, fields.availableDPCalculated.value ? [
                        `${__('calculated')}: ${fields.availableDPCalculated.value}`
                    ] : [])}
                    {this.renderGenericHorizontalField(fields.cvFlow, {}, fields.cvFlowCalculated.value ? [
                        `${__('calculated')}: ${fields.cvFlowCalculated.value}`
                    ] : [])}
                    {fields.neededKVS.visible && <StepHorizontalField label={fields.neededKVS.label}>
                        <span className="horizontal-field-value-text">{fields.neededKVS.value || 0}</span>
                    </StepHorizontalField>}
                </div>
                <div className="control-valve column-12 column-xs-12">
                    <div className="heating-horizontal-field">
                        <div className="heating-horizontal-field-label" style={{width: '41.6%'}}></div>
                        <div className="heating-horizontal-field-input" style={{width: '58.3%'}}>
                            <Row.Container hasOuterGutter={false} className="w-100">
                                {valveFields.map((field, idx) => (
                                    <Row.Column6 key={idx}>
                                        <span
                                            className="configuration-editor-controller-heating-label">CV{idx + 1}</span>
                                    </Row.Column6>
                                ))}
                            </Row.Container>
                        </div>
                    </div>
                    {this.props.model.primarySideEquipment.picv.value ? this.renderCV('Control valve', picvValveFields, true) : this.renderCV('Control valve', valveFields)}
                    {this.renderCV('KVS', kvsFields)}
                    {this.renderCV('Actuator type', actuatorTypeFields)}
                </div>
                <div className="column-8 column-xs-12">
                    {fields.totalKVS.visible && <StepHorizontalField label={fields.totalKVS.label}>
                        <span className="horizontal-field-value-text">{fields.totalKVS.value}</span>
                    </StepHorizontalField>}

                    {isHeating && this.renderGenericHorizontalField(fields.isSummerShutOff, {label: ''})}

                    {fields.controlValvePressureDrop.visible &&
                        <StepHorizontalField label={fields.controlValvePressureDrop.label} className="label-field">
                            <span
                                className="horizontal-field-value-text">{fields.controlValvePressureDrop.value} {fields.controlValvePressureDrop.unit}</span>
                            {fields.controlValvePressureDrop.warning &&
                                <WarningsContainer warning={fields.controlValvePressureDrop.warning}/>}
                        </StepHorizontalField>}
                </div>
                {heatingModel !== null && heatingModel.heatPumpConnectionsIncluded.value && heatingModel.heatPumpConnectionType.value === 1 &&
                    <React.Fragment>
                        {this.renderThreeWayValve(fields)}
                        {this.renderThreeWayValvePressureDropAndKVS(fields)}
                    </React.Fragment>
                }
            </React.Fragment>
        )
    }

    renderThreeWayValve = fields => {
        const {valveFields, kvsFields, actuatorTypeFields} = this.get3WVControls(fields);

        return (
            <div className="control-valve column-12 column-xs-12">
                <div className="heating-horizontal-field">
                    <div className="heating-horizontal-field-label" style={{width: '41.6%'}}></div>
                    <div className="heating-horizontal-field-input" style={{width: '58.3%'}}>
                        <Row.Container hasOuterGutter={false} className="w-100">
                            <Row.Column6>
                                <span className="configuration-editor-controller-heating-label">3-way valve</span>
                            </Row.Column6>
                        </Row.Container>
                    </div>
                </div>
                {this.renderCV('Control valve', valveFields)}
                {this.renderCV('KVS', kvsFields)}
                {this.renderCV('Actuator type', actuatorTypeFields)}
            </div>
        );
    }

    renderThreeWayValvePressureDropAndKVS = fields => (
        <div className="column-8 column-xs-12">
            {fields.threeWayValvePressureDrop.visible &&
                <StepHorizontalField label={fields.controlValvePressureDrop.label} className="label-field">
                    <span
                        className="horizontal-field-value-text">{fields.threeWayValvePressureDrop.value} {fields.threeWayValvePressureDrop.unit}</span>
                    {fields.threeWayValvePressureDrop.warning &&
                        <WarningsContainer warning={fields.threeWayValvePressureDrop.warning}/>}
                </StepHorizontalField>}
        </div>
    )

    renderCV(label, fields, possibleDefaultValue) {

        const visible = fields.some(x => x.visible);
        if (!visible) {
            return <React.Fragment/>
        }

        const onDefaultButtonClick = field => {
            field.value = this.getDefaultValueFromList(field);
            store.recentlyChangedField = field.getModelPath()
            this.props.onFormModelChange();
        }

        const withDefaultValue = field => {
            return possibleDefaultValue && this.getDefaultValueFromList(field);
        }

        const anyFieldWithDefaultValue = () => {
            return possibleDefaultValue && fields.some(x => this.getDefaultValueFromList(x));
        }

        return (
            <div className={`heating-horizontal-field cv ${anyFieldWithDefaultValue() ? 'with-default-button' : ''}`}>
                <div className="heating-horizontal-field-label" style={{width: '41.6%'}}>{__(label)}</div>
                <div className="heating-horizontal-field-input" style={{width: '58.3%'}}>
                    <Row.Container hasOuterGutter={false} className="w-100">
                        {fields.map((field, idx) => (
                            <Row.Column6 key={idx}>
                                {this.renderFieldv2(field)}
                                {withDefaultValue(field) && <div className="heating-horizontal-field-default"
                                                                 onClick={() => onDefaultButtonClick(field)}>
                                    {__('DEF')}
                                </div>}
                            </Row.Column6>
                        ))}
                    </Row.Container>
                </div>
            </div>
        )
    }

    static getFields(step) {
        const createField = name => new Field(name, step)
        const createCircuitSection = name => ({
            numberOfControlValves: createField(name + '.numberOfControlValves'),
            availableDP: createField(name + '.availableDP'),
            availableDPCalculated: createField(name + '.availableDPCalculated'),
            controlValvePressureDrop: createField(name + '.controlValvePressureDrop'),
            threeWayValvePressureDrop: createField(name + '.threeWayValvePressureDrop'),
            cvFlow: createField(name + '.cvFlow'),
            cvFlowCalculated: createField(name + '.cvFlowCalculated'),
            neededKVS: createField(name + '.neededKVS'),
            temperatureSensorPrimaryReturn: createField(name + '.temperatureSensorPrimaryReturn'),
            thermometerPrimaryHeatingReturn: createField(name + '.thermometerPrimaryHeatingReturn'),
            totalKVS: createField(name + '.totalKVS'),
            threeWayValveTotalKVS: createField(name + '.threeWayValveTotalKVS')
        })

        const createHeatingSection = name => ({
            ...createCircuitSection(name),
            isSummerShutOff: createField(name + '.isSummerShutOff'),
        })

        const createDHWSection = name => ({
            ...createCircuitSection(name)
        })

        const createCVSection = (name, idx) => ({
            controlValve: createField(name + '.cV' + idx + '.controlValve'),
            actuatorType: createField(name + '.cV' + idx + '.actuatorType'),
            kvs: createField(name + '.cV' + idx + '.kvs'),
            controlValvePICV: createField(name + '.cV' + idx + '.controlValvePICV'),
        })

        const create3WayValveSection = name => ({
            controlValve: createField(name + '.threeWayValve.controlValve'),
            actuatorType: createField(name + '.threeWayValve.actuatorType'),
            kvs: createField(name + '.threeWayValve.kvs'),
        })

        return {
            availableHEtoDHRetOrPreh: createField('availableHEtoDHRetOrPreh'),
            availableHEtoDHRetOrPrehDN: createField('availableHEtoDHRetOrPrehDN'),
            picv: createField('picv'),
            controlValveManufacturer: createField('controlValveManufacturer'),
            primaryMainPipeSize: createField('primaryMainPipeSize'),
            flangedControlValvesDemanded: createField('flangedControlValvesDemanded'),
            rtzActuatorDemanded: createField('rtzActuatorDemanded'),
            differentialPressureControllerDPC: createField('differentialPressureControllerDPC'),
            primaryFlowForDPCSizing: createField('primaryFlowForDPCSizing'),
            differentialPressureController: createField('differentialPressureController'),
            dpcPressureDrop: createField('dpcPressureDrop'),
            reservedPressureDropForDPCPercent: new ReservedPressureDropForDPCPercent('reservedPressureDropForDPCPercent', step),
            reservedPressureDropForDPCPressureDrop: new ReservedPressureDropForDPCPressure('reservedPressureDropForDPCPressureDrop', step),
            dhStrainer: createField('dhStrainer'),
            energyMeter: createField('energyMeter'),
            primaryOutPipeEMS: createField('primaryOutPipeEMS'),
            dhFlowRetShutOff: createField('dhFlowRetShutOff'),
            pressureMetering: createField('pressureMetering'),
            primaryTotalFlow: createField('primaryTotalFlow'),
            thermometerPrimaryReturn: createField('thermometerPrimaryReturn'),
            thermometerPrimarySupply: createField('thermometerPrimarySupply'),
            heating1: {
                ...createHeatingSection('heating1'),
                cv1: createCVSection('heating1', 1),
                cv2: createCVSection('heating1', 2),
                cv3: createCVSection('heating1', 3),
                threeWayValve: create3WayValveSection('heating1')
            },
            heating2: {
                ...createHeatingSection('heating2'),
                cv1: createCVSection('heating2', 1),
                cv2: createCVSection('heating2', 2),
                cv3: createCVSection('heating2', 3),
                threeWayValve: create3WayValveSection('heating2')
            },
            heating3: {
                ...createHeatingSection('heating3'),
                cv1: createCVSection('heating3', 1),
                cv2: createCVSection('heating3', 2),
                cv3: createCVSection('heating3', 3),
                threeWayValve: create3WayValveSection('heating3')
            },
            dhw: {
                ...createDHWSection('dhw'),
                cv1: createCVSection('dhw', 1),
                cv2: createCVSection('dhw', 2),
                cv3: createCVSection('dhw', 3)
            },
            tedhFlow: createField('tedhFlow'),
            tedhRet: createField('tedhRet'),
            shutOffValvePrimarySupply: createField('shutOffValvePrimarySupply'),
            shutOffValvePrimaryReturn: createField('shutOffValvePrimaryReturn')
        }
    }

    static getStepModel(model) {
        return new StepModel('primarySideEquipment', model.primarySideEquipment)
    }
}